import ApiService from '@/core/services/api.service';
import { validateLineVouchers } from '@/services/voucher/voucherV2.api';

export default {
  validateLine: validateLineVouchers,

  async validateCoupon({
    couponCode,
    storeId,
    customerId,
    products = [],
    totalAmount = 0,
    stackedDiscountProgramIds,
  }) {
    try {
      const payload = {
        couponCode,
        storeId,
        customerId,
        products: products.map((product) => ({
          productId: product.productId || product.id,
          quantity: product.quantity,
          price: product.sellingPrice || product.price,
        })),
        totalAmount,
      };
      if (
        Array.isArray(stackedDiscountProgramIds) &&
        stackedDiscountProgramIds.length > 0
      ) {
        payload.stackedDiscountProgramIds = stackedDiscountProgramIds.map((id) =>
          Number(id),
        );
      }

      const response = await ApiService.post('v1/vouchers/validate', payload);

      if (response.data.status === 200) {
        return {
          status: 1,
          message: response.data.message,
          data: {
            discountAmount: response.data.data.discountAmount,
            discountType: 1,
            couponInfo: response.data.data.couponInfo,
          },
        };
      } else {
        return {
          status: 0,
          message: response.data.message || 'Có lỗi xảy ra khi kiểm tra coupon',
        };
      }
    } catch (error) {
      console.error('Coupon validation error:', error);

      if (error.response && error.response.data) {
        return {
          status: 0,
          message: error.response.data.message || 'Mã coupon không hợp lệ',
        };
      }

      return {
        status: 0,
        message: 'Có lỗi xảy ra khi kiểm tra mã coupon',
      };
    }
  },
};
